import React from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import "../../assets/css/pricing.css";

const FEATURES = [
  "AI-powered personal assistant",
  "Task & note management",
  "Reminders & calendar",
  "Grocery lists & meal planning",
  "Web search & deep research",
  "Voice AI conversations",
  "Google integrations (Calendar, Gmail, Drive, Docs)",
  "Second Brain (PARA method)",
  "Meeting management",
  "File storage & attachments",
  "Memory & personalization",
  "Priority support",
];

const PLANS = [
  {
    name: "Starter",
    price: 10,
    credits: 500,
    popular: false,
    tagline: "Perfect for getting started",
    bonus: null,
  },
  {
    name: "Pro",
    price: 50,
    credits: 3000,
    popular: true,
    tagline: "Best value for power users",
    bonus: "500 bonus credits included",
  },
];

const PricingPage = () => {
  const isDarkMode = Cookies.get("isDarkMode") === "true";

  return (
    <div className="pricing-page">

      {/* Nav */}
      <nav className="pricing-topbar">
        <div className="pricing-topbar-inner">
          <Link to="/login" className="zoomey-logo-wrapper">
            <div className={`zoomey-logo-mark ${isDarkMode ? "dark" : "light"}`}>
              <div className="logo-glow"></div>
              <div className="logo-inner">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 7H22L8 21H22" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="z-path" />
                  <circle cx="22" cy="7" r="2" fill="currentColor" className="z-dot" />
                </svg>
              </div>
            </div>
            <div className="zoomey-brand-text">
              <span className={`brand-name ${isDarkMode ? "dark" : "light"}`}>ZOOMEY</span>
            </div>
          </Link>
          <div className="pricing-topbar-right">
            <Link to="/faq" className="pricing-topbar-link">FAQ</Link>
            <Link to="/terms-and-conditions" className="pricing-topbar-link">Terms</Link>
            <Link to="/privacy-policy" className="pricing-topbar-link">Privacy</Link>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <header className="pricing-hero">
        <div className="pricing-hero-bg-grid"></div>
        <div className="pricing-hero-inner">
          <div className="pricing-hero-badge">
            <i className="bi bi-tag-fill"></i>
            Simple Pricing
          </div>
          <h1 className="pricing-hero-title">Plans that grow with you</h1>
          <p className="pricing-hero-sub">
            No hidden fees, no surprises. Cancel anytime.
          </p>
        </div>
      </header>

      {/* Plans Grid */}
      <main className="pricing-main">
        <div className="pricing-grid">
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={`pricing-card ${plan.popular ? "pricing-card-popular" : ""}`}
            >
              {plan.popular && (
                <div className="pricing-popular-badge">Best Value</div>
              )}
              <div className="pricing-card-header">
                <h3 className="pricing-plan-name">{plan.name}</h3>
                <p className="pricing-tagline">{plan.tagline}</p>
                <div className="pricing-price">
                  <span className="pricing-currency">$</span>
                  <span className="pricing-amount">{plan.price}</span>
                  <span className="pricing-period">/mo</span>
                </div>
                <div className="pricing-credits">
                  {plan.credits.toLocaleString()} credits/month
                </div>
                {plan.bonus && (
                  <div className="pricing-bonus-badge">
                    <i className="bi bi-gift"></i>
                    {plan.bonus}
                  </div>
                )}
              </div>
              <ul className="pricing-features">
                {FEATURES.map((f, i) => (
                  <li key={i}>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <Link to="/login" className={`pricing-cta ${plan.popular ? "pricing-cta-primary" : ""}`}>
                Get Started
              </Link>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="pricing-bottom-cta">
          <p>Have questions about which plan is right for you?</p>
          <a href="mailto:support@playces.in" className="pricing-contact-link">
            <i className="bi bi-envelope"></i>
            Contact us at support@playces.in
          </a>
        </div>
      </main>

      {/* Footer */}
      <footer className="pricing-footer">
        <div className="pricing-footer-inner">
          <div className="pricing-footer-left">
            <span className="pricing-footer-brand">ZOOMEY</span>
            <span>&copy; 2026 Playces.in. All rights reserved.</span>
          </div>
          <div className="pricing-footer-links">
            <Link to="/pricing">Pricing</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/login">Sign In</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage;
